import dayjs from "dayjs";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import CommonIcons from "../../../assets/icons";
import CommonComponents from "../../Commons";
import useToggle from "../../../hooks/useToggle";



const formatValue = (value: any, field: any) =>
{
   // Only show "-" for undefined or null
   if (value === undefined || value === null) return "-";

   // 🔥 Handle array (multi select, etc.)
   if (Array.isArray(value))
   {
      if (value.length === 0) return "-";

      // Nếu có enum → map label
      if (field?.enum)
      {
         return value
            .map((v) =>
            {
               const found = field.enum.find((e: any) => e.value === v);
               return found?.label || v;
            })
            .join(", ");
      }

      return value.join(", ");
   }

   // Enum (single)
   if (field?.enum)
   {
      const found = field.enum.find((e: any) => e.value === value);
      return found?.label || value;
   }

   // Date
   if (field?.format === "date" || field?.format === "date-time")
   {
      return dayjs(value).format("DD/MM/YYYY");
   }

   // Number
   if (field?.type === "number")
   {
      return Number(value).toLocaleString();
   }

   return String(value);
};

const dataWarning = {
   title: 'Requests for new photos are possible.',
   content: 'Your requirements can be met with the selected specifications. Once the price is agreed upon, a quotation will be sent to you. Average delivery time: 1-3 days.'

}
const ConfirmStep = ({
   formData,
   fieldMeta,
   stepFieldMap,
   workflow,
   onBack,
   onSubmit,
   totalSteps,
}: any) =>
{
   const { t } = useTranslation();



   return (
      <div className="relative flex flex-col h-full overflow-hidden">
         <div className="p-6 ">
            <h1 className="text-xl font-semibold">{t("Confirm order")}</h1>
            <p className="text-gray-400 text-sm mt-1">
               {t("Step")} {totalSteps + 1}/{totalSteps + 1}
            </p>
         </div>
         <div className="overflow-auto !px-6" style={{ height: 'calc(100% - 88px - 65px)' }}>
            <div className="div-warning-info mb-6 flex gap-4">
               <span><CommonIcons.InfoCircleIcon /></span>
               <div><p style={{ fontSize: '14px', fontWeight: 600 }}>{
                  t(dataWarning.title)
               }</p>
                  <p style={{ fontSize: '14px', fontWeight: 450 }}>{
                     t(dataWarning.content)
                  }</p></div>

            </div>
            <div className="space-y-6">
               {workflow?.steps?.map((step: any, index: number) =>
               {
                  const stepId = step.step_id ?? step.id;
                  const fields = stepFieldMap?.[stepId];

                  // bỏ step không có field
                  if (!fields || fields.length === 0) return null;

                  return (
                     <div
                        key={stepId}
                        style={{ borderBottom: index < workflow?.steps.length - 1 ? '1px solid #2B364F' : '', paddingBottom: '12px' }}
                     >

                        <div className="space-y-2">
                           {fields?.filter((itemF?: any) => itemF !== 'geometry').map((key: string) =>
                           {


                              const field = fieldMeta?.[key];
                              const label = field?.title || key;
                              const value = formData?.[key];



                              return (
                                 <div
                                    key={key}
                                    className="flex justify-between text-sm pb-[10px] w-full"
                                 >
                                    <span className="text-gray-400 w-1/3">{t(label)}</span>
                                    <span className="text-white flex justify-end w-2/3">
                                       {formatValue(value, field)}
                                    </span>
                                 </div>
                              );
                           })}
                        </div>
                     </div>
                  );
               })}
            </div>
         </div>



         <div className="flex justify-between bg-[#0f172a] px-6 py-4 border-t border-[#2a344d] absolute bottom-0 w-full">
            <Button className="btn-outline" onClick={onBack}>{t("Back")}</Button>

            <Button className="btn-primary" onClick={onSubmit}>
               {t("Create request")}
            </Button>


         </div>
      </div>
   );
};

export default ConfirmStep;
